export default __webpack_public_path__ + "9c66c795454850e406ed0060e3c79277.png";